<adapt-auth-audit [showUserFilter]="true"></adapt-auth-audit>
